import {ApiError, send} from "./http";
import {tokenStore} from "../auth/tokenStore";

// Calls that need the signed-in user. Renews the access token when it's about to expire, and once more
// if the API still refuses it (401). Throws ApiError(401) when there's no session.
export async function authorized<T>(method: string, path: string, body?: unknown): Promise<T> {
    const accessToken = await tokenStore.accessToken();
    if (!accessToken) {
        throw new ApiError(401);
    }
    try {
        return await send<T>(method, path, body, accessToken);
    } catch (err) {
        if (!(err instanceof ApiError) || err.status !== 401) {
            throw err;
        }
        const renewed = await tokenStore.refresh(accessToken);
        if (!renewed) {
            throw err;
        }
        return await send<T>(method, path, body, renewed);
    }
}

// Calls anyone can make, with the access token when someone's signed in: in maintenance mode, the API answers only
// administrators' calls, public ones included. Never throws ApiError(401) for want of a session.
export async function optionallyAuthorized<T>(method: string, path: string, body?: unknown): Promise<T> {
    const accessToken = await tokenStore.accessToken().catch(() => null);
    return await send<T>(method, path, body, accessToken ?? undefined);
}
